import { useState } from "react";
import request from "../../../../helpers/request";
import endpoints from "../../../../helpers/endpoints";

export default function FSAMatchActions({ FHRSID, onUpdated, translations }) {
    const [overrideUprn, setOverrideUprn] = useState("");

    const disabled = !FHRSID;

    const submitDecision = (decision, extra = {}) => {
        if (!FHRSID) return;
        request(true).post(endpoints.FSA_MATCH_UPDATE, {
            FHRSID,
            decision,
            ...extra
        }).then(() => {
            setOverrideUprn("");
            onUpdated?.();
        }).catch(e => {
            console.error(e);
        })
    }

    const submitAccept = () => submitDecision("ACCEPT");
    const submitReject = () => submitDecision("REJECT");
    const submitOverride = () => {
        if (!overrideUprn) return;
        submitDecision("OVERRIDE", { uprn: overrideUprn });
    }

    return (
        <div className="grid grid-gap-15 fsa-match-actions">
            <button className={`button compact colour-white ${disabled ? 'background-gray' : 'background-primary'}`} disabled={disabled} onClick={submitAccept}>{translations['accept'] ?? 'Accept'}</button>
            <button className={`button compact colour-white ${disabled ? 'background-gray' : 'background-primary'}`} disabled={disabled} onClick={submitReject}>{translations['reject'] ?? 'Reject'}</button>
            <button className={`button compact colour-white ${overrideUprn ? 'background-primary' : 'background-gray'}`} disabled={!overrideUprn} onClick={submitOverride}>{translations['override'] ?? 'Override'}</button>
            <input
                type="text"
                value={overrideUprn}
                onChange={(e) => setOverrideUprn(e.target.value)}
                placeholder={translations['uprn'] ?? 'UPRN'}
                className="data-row-field"
            />
        </div>
    )
}
